import React from 'react';
import CalendarIcon from '@assets/icons/calendar-icon.svg';
import DatePicker from 'react-datepicker';
import { IconButton, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';

const MyOperationDatePicker = (
  { from, to, handleFromDate, handleToDate, minTime, showDayPickerInput, resetDateValues }) => {
  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid>
        <IconButton onClick={() => showDayPickerInput('daypickerone')}>
          <img src={CalendarIcon} className='icon my-2' alt='' />
        </IconButton>
      </Grid>
      <Grid>
        <DatePicker
          selected={from}
          onChange={handleFromDate}
          minTime={minTime}
          maxTime={new Date().setHours(23, 59)}
          showMonthDropdown
          showYearDropdown
          dateFormat="dd/MM/yyyy"
          className="form-control mt-1 text-left"
          placeholderText="De"
          isClearable
        />
      </Grid>
      <Grid>
        <IconButton onClick={() => showDayPickerInput('daypickertwo')}>
          <img src={CalendarIcon} className='icon my-2' alt='' />
        </IconButton>
      </Grid>
      <Grid>
        <DatePicker
          selected={to}
          onChange={handleToDate}
          minTime={minTime}
          maxTime={new Date().setHours(23, 59)}
          showMonthDropdown
          showYearDropdown
          dateFormat="dd/MM/yyyy"
          className="form-control mt-1 text-left"
          placeholderText="A"
          isClearable
          shouldCloseOnSelect={false}
        />
      </Grid>
      {from && to && (
        <Grid>
          <Button onClick={resetDateValues} sx={{ minWidth: 0 }}>
            &times;
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default React.memo(MyOperationDatePicker);
//Original code:
/*import React from 'react';
import CalendarIcon from '@assets/icons/calendar-icon.svg';
import DatePicker from 'react-datepicker';

const MyOperationDatePicker = ({ from, to, handleFromDate, handleToDate, minTime,
	showDayPickerInput }) => {
	return (
		<>
			<Col sm='auto'>
				<img
					src={CalendarIcon}
					className='icon my-2'
					alt=''
					onClick={() => showDayPickerInput('daypickerone')}
				/>
			</Col>
			<Col>
				<label>
					<DatePicker
						selected={from}
						onChange={handleFromDate}
						minTime={minTime}
						id='input-date-from'
						showMonthDropdown
						showYearDropdow
						maxTime={new Date().setHours(23, 59)}
						dateFormat='dd/MM/yyyy'
						className='form-control mt-1 text-left'
						placeholderText='De'
						isClearable={true}
					/>
				</label>
			</Col>
			<Col sm='auto'>
				<img
					src={CalendarIcon}
					className='icon my-2 MyOperation-img-input Fielder-icon-button'
					onClick={() => showDayPickerInput('daypickertwo')}
					alt=''
				/>
			</Col>
			<Col>
				<label>
					<DatePicker
						selected={to}
						onChange={handleToDate}
						minTime={minTime}
						showMonthDropdown
						showYearDropdow
						maxTime={new Date().setHours(23, 59)}
						dateFormat='dd/MM/yyyy'
						className='form-control mt-1 text-left'
						placeholderText='A'
						isClearable={true}
						shouldCloseOnSelect={false}
					/>
				</label>
			</Col>
			{from != null && to != null && (
				<Col sm='auto' className='mt-1'>
					<button
						key='btn-close'
						id='btn-close'
						className='close'
						aria-label='Close'
						onClick={() => resetDateValues()}
					>
						<span style={{ fontSize: '20px' }} aria-hidden='true'>
							&times;
						</span>
					</button>
				</Col>
			)}
		</>
	);

}
export default React.memo(MyOperationDatePicker);*/
